export default {"src":"/_next/static/media/icon-facebook.806992b0.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};